<footer>
    
    <div class="c-footer">
        <p>Madero Cashback é o Programa de Fidelidade do Grupo Madero.</p>
        <p class="c-footer__terms">
            <span (click)="onRedirect('privacy')" class="c-cursor">Politicas de Privacidade</span> | 
            <span (click)="onRedirect('terms')" class="c-cursor">Termos de uso</span>                    
        </p>
    </div>
</footer>